import React from 'react';
import ArrowBack from '@mui/icons-material/ArrowBackRounded';
import ArrowForward from '@mui/icons-material/ArrowForwardRounded';
import { useTranslation } from 'react-i18next';

import './JumbotronPager.scss';
import { Button } from 'components/Shared/Inputs';

interface JumbotronPagerProps {
    index: number,
    total: number,
    onChange: (index: number) => void
}


export const JumbotronPager: React.FC<JumbotronPagerProps> = (props) => {
    const { index, total, onChange } = props;

    const { t } = useTranslation('dashboard', { useSuspense: false });

    return (
        <div className="jumbotron_pager_container">
            <Button variant="opaque" round aria-label={t('previous_slide')}
                disabled={index <= 0} onClick={() => onChange(index - 1)}
            >
                <ArrowBack/>
            </Button>
            <div className="pager">
                <strong>{`${index + 1} / ${total}`}</strong>
            </div>
            <Button variant="opaque" round aria-label={t('next_slide')}
                disabled={index >= total - 1} onClick={() => onChange(index + 1)}
            >
                <ArrowForward/>
            </Button>
        </div>
    )
}